// extracted by mini-css-extract-plugin
export var alignCenter = "_7s-d";
export var bannerShown = "_7s-6";
export var buttonContent = "_7s-0";
export var cardList = "_7s-1";
export var centerContent = "_7s-2";
export var chevron = "_7s-3";
export var closePanelButton = "_7s-k";
export var conversationContextContainer = "_7s-l";
export var conversationDetailContainer = "_7s-4";
export var detailWrapper = "_7s-7";
export var dropdownButton = "_7s-e";
export var dropdownTitle = "_7s-9";
export var fullHeight = "_7s-5";
export var hidden = "_7s-a";
export var icon = "_7s-b";
export var mergeSuggestionWrapper = "_7s-m";
export var panel = "_7s-i";
export var portalButtonsWrapper = "_7s-c";
export var right = "_7s-j";
export var tableSummaryContainer = "_7s-8";
export var tableSummaryHeader = "_7s-g";
export var threeDotsButton = "_7s-f";
export var wide = "_7s-h";